import { render, staticRenderFns } from "./MultiTextfieldComponent.vue?vue&type=template&id=5396030c&"
import script from "./MultiTextfieldComponent.vue?vue&type=script&lang=js&"
export * from "./MultiTextfieldComponent.vue?vue&type=script&lang=js&"
import style0 from "./MultiTextfieldComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports